import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhoItsForSection() {
  const audiences = ['Mold remediation professionals', 'Pest control', 'Janitorial and sanitation crews', 'Facilities maintenance teams', 'Property managers', 'Agricultural and horticultural use', 'Specialty surface treatment contractors'];
  return <section className="py-16 bg-brand-light" data-id="element-820">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-821">
        <h2 className="text-3xl font-bold text-brand-dark mb-4" data-id="element-822">
          Who It's For
        </h2>
        <p className="text-xl text-gray-600 mb-8" data-id="element-823">Ideal for:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-824">
          {audiences.map((audience, index) => <div key={index} className="flex items-center p-4 bg-white rounded-lg border border-gray-200" data-id="element-825">
              <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-3 flex-shrink-0" data-id="element-826" />
              <span className="text-gray-700" data-id="element-827">{audience}</span>
            </div>)}
        </div>
      </div>
    </section>;
}